// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__39w71","head":"ProcedureTableInfo_head__3Q36V"};